import { mutatorAction } from 'satcheljs';

import type FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import type AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';

export default mutatorAction(
    'updateFilePickerPagingMetadata',
    (state: FilePickerPanelViewState, metadata: AttachmentItemsPagingMetadata) => {
        state.filePickerViewState.pagingMetadata = metadata;
    }
);
